import { generateUID } from '@aytm/app/insights/dashboard/lib/strings'
import { List, Map, Set, OrderedMap, OrderedSet } from 'immutable'
export function isImmutable(input: unknown) {
  return Boolean(
    List.isList(input) ||
      Map.isMap(input) ||
      Set.isSet(input) ||
      OrderedSet.isOrderedSet(input) ||
      OrderedMap.isOrderedMap(input)
  )
}
export function asRequiredUID(generator = generateUID) {
  return function (x?: string) {
    return 'string' == typeof x ? x : generator()
  }
}
